import React from "react";

const pad = (n) => String(n).padStart(2, "0");

const ProjectCard = ({ project, index, section }) => {
  return (
    <article className="group border-t border-lab-rule">
      <div className="grid grid-cols-12 gap-6 py-10 md:py-14">
        {/* Index */}
        <div className="col-span-12 md:col-span-2 font-mono text-[11px] tracking-widest uppercase text-lab-paper-dim">
          <div>{section} / {pad(index)}</div>
          <div className="text-lab-accent mt-1">{project.status}</div>
          {project.aiTags && project.aiTags.length > 0 && (
            <div className="mt-4 pt-3 border-t border-lab-rule flex flex-col gap-1.5">
              {project.aiTags.map((tag) => (
                <span
                  key={tag}
                  className="inline-flex items-center gap-2 text-lab-paper"
                >
                  <span className="w-1 h-1 bg-lab-accent rounded-full" />
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>

        {/* Title + description */}
        <div className="col-span-12 md:col-span-6">
          <h3 className="font-display text-4xl md:text-5xl font-semibold tracking-tightest text-lab-paper leading-none">
            {project.name}
          </h3>
          <p className="mt-4 text-lab-paper-dim text-sm md:text-base leading-relaxed max-w-xl">
            {project.description?.replace(/\*\*/g, "")}
          </p>

          {project.specs && (
            <dl className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-x-4 gap-y-3 max-w-xl">
              {project.specs.map((spec, idx) => (
                <div key={idx} className="border-t border-lab-rule pt-2">
                  <dt className="font-mono text-[10px] tracking-widest uppercase text-lab-paper-dim">
                    {pad(idx + 1)}
                  </dt>
                  <dd className="font-mono text-[12px] text-lab-paper mt-0.5">
                    {spec}
                  </dd>
                </div>
              ))}
            </dl>
          )}
        </div>

        {/* Image */}
        <div className="col-span-12 md:col-span-4">
          <div className="relative aspect-square bg-lab-panel border border-lab-rule overflow-hidden">
            <img
              src={project.imgSrc}
              alt={project.name}
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between px-3 py-2 font-mono text-[10px] tracking-widest uppercase text-lab-paper bg-lab-ink/80 backdrop-blur-sm border-t border-lab-rule">
              <span>REF · {project.name.toUpperCase()}</span>
              <span className="text-lab-paper-dim">{section}</span>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default ProjectCard;
